import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth.slices';
import systemReducer from './slices/system.slices';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    system: systemReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
